<template>
  <div class="sendMessageInfo">
    <k-dialog
      class="uploadModel"
      ref="sendMessageDialog"
      :options="{
        title:title,
        center: true,
        width: '50%',
        top: '0',
        destroyOnClose: true,
        isCanClickClose: false,
        showClose: true,
        onCloseBefore: closeMsg,
        buttons: [
          { text: '取消', handler: closeMsg },
          { text: '确定', handler: closeMsg }
        ]
      }"
    >
      <div class="openModal">
        <div class="modal-body">
          <div class="update_main">
            <div class="item">
              <el-form :model="{}">
                <k-input id="MOBILE_TEL" :label="phoneText" placeholder="请输入手机号码" :value.sync="MOBILE_TEL"
                  validtype="mobile|on-change" :buttontxt="newMobileButtonTxt" :buttonEnable="mobileButtonEnable"
                  :clickButton="getSmsValidCode" :disabled="disAbledMobileNo" :required="true" />
                <div class="msg" v-show="messageSend">{{ messageSend }}</div>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </k-dialog>
  </div>
</template>

<script>
import kDialog from "../../common/dialog.vue";
import kInput from "@/components/baseUI/kInput";
import smsService from "@/service/sms-service";

export default {
  props: {
    riskModel: {
      type: Boolean
    },
    title: {
      type: String,
      default:"风险测评试题已更新，需重新进行风险测评。",
    },
    MOBILE_TEL: {//手机号码
      type: String,
      default:"",
    },
    phoneText: {
      type: String,
      default:"代理人手机号码",
    },
    mobileButtonTxt: {//验证手机号码按钮值
      type: String,
      default:"发送风险测评短信",
    },
    disAbledMobileNo:  {//手机号码禁止修改
      type: Boolean,
      default: true,
    },

  },
  components: {
    kDialog,
    kInput
  },
  data () {
    return {
      mobileButtonEnable: false, //验证手机号码按钮是否禁用
      newMobileButtonTxt:"",
      interTimer:null,
      messageSend: false,
    };
  },
  computed: {
    apptSn () {
      return this.$store.state.apptSn;
    },
    busiCode () {
      return this.$store.state.busicode;
    },
    userType () {
      return this.$store.state.usertype;
    },
  },
  mounted () {
    this.newMobileButtonTxt = this.mobileButtonTxt;
    this.$refs.sendMessageDialog.open();
  },
  methods: {
    //发送短信验证码
    async getSmsValidCode () {
      this.$store.commit(this.$types.UPDATE_LOADING, "正在发送");
      if (!this.MOBILE_TEL || !(/^([+]?[\d]{1,3}-|[ ])?((13[0-9]{9})|(18[0-9]{9})|(15[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(16[0-9]{9})|(19[0-9]{9}))$/).test(this.MOBILE_TEL)) {
        alert("请输入正确的手机号码");
        return false;
      }
      let params ={  
        APPT_SN: this.apptSn || "",
        type: 2,
        phoneNo: this.MOBILE_TEL,
        BUSI_CODE: this.busiCode,
        USER_TYPE: this.userType,
        isCust: "1",//风险测评是发给客户的，由客户登录，所以为1
      };
      let that = this;
      smsService.sendSmsMsg(params).then(function (resultObj) {
        let remainTime = 300;
        if (!resultObj.time) {
          that.alert({
            messageText: "信息已发送到：【" + params.phoneNo + "】，请注意查收！",
          });
        } else {
          remainTime = resultObj.time;
          that.alert("获取验证码失败:"+resultObj.msg);
        }
        that.mobileButtonEnable = true;
        that.interTimer = setInterval(function () {
          remainTime--;
          that.newMobileButtonTxt = `${remainTime}秒`;
        }, 1000);
        if(resultObj.code){
          that.messageSend = resultObj.code;// 测试用，在pc上做试题
        }
        setTimeout(() => {
          that.mobileButtonEnable = false;
          that.newMobileButtonTxt = this.mobileButtonTxt;
          clearInterval(that.interTimer);
        }, remainTime*1000);
      });
    },
    closeMsg () {
      // this.modelClose = false;
      // this.$emit("on-change", this.modelClose);
    },
  }
};
</script>

<style lang="less" scoped>
.sendMessageInfo{
  .commom-dialog{
    .el-form{
      padding: 0.2rem;
    }
    .el-form-item{
      width: 80%;
      margin-left: 0;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/imageNode/child/sendMessage.vue